import { useState } from 'react';
import { useForm } from 'react-hook-form';
import SuccessErrorMsg from "../../../../utilities/SuccessErrorMsg"
import { emailValidation, mobileValidation } from "../../../../utilities/validations/inputsValidations"
import { toast, ToastContainer } from "react-toastify";
import { addAdvServicesform } from '../../../../hooks/apiAxios';


export function AddAdvancedService() {
    const { register, handleSubmit, formState: { errors }, setValue } = useForm({
        defaultValues: {
            type: "advanced",
        }
    });
    const [loading, setLoading] = useState(false);

    async function onSubmit(data) {
        setLoading(true);
        console.log(data);

        const formData = new FormData();

        // // Append file if you're using image uploads
        // if (data.image && data.image[0]) {
        //     formData.append("image", data.image[0]);
        // }

        // Append other form fields
        formData.append("image", data.image);
        formData.append("name", data.name);
        formData.append("nameAr", data.nameAr);
        formData.append("enabled", data.enabled);
        formData.append("description", data.description);
        formData.append("descriptionAr", data.descriptionAr);


        // Prepare supplier info as JSON array
        const supplierArray =
        {
            "name": data.supplier?.name,
            "email": data.supplier?.email,
            "phone": data.supplier?.phone,
        };

        // Append supplier JSON
        formData.append("supplier", JSON.stringify(supplierArray));

        try {
            const response = await addAdvServicesform(formData);

            if (response.data.isSuccess) {
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
            } else {
                toast.error("حدث خطأ ما، حاول مرة أخرى");
            }
        } catch (error) {
            console.error("Error during form submission: ", error);
            toast.error("حدث خطأ ما، تواصل مع الدعم");
        } finally {
            setLoading(false);
        }
    }


    return (
        <div id="add-AdvancedService"
            className="modal fade bg-transparent"
            tabIndex="-1"
            aria-hidden="true"
            aria-labelledby="AdvServiceAddForm"
            data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="AdvServiceAddForm">إضافة خدمة</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body p-0">
                        <form encType="multipart/form-data" method="patch"
                            className='d-flex flex-column flex-md-row shadow mx-auto gap-2 text-start bg-white px-2 pb-4 rounded align-items-center'
                            onSubmit={handleSubmit(onSubmit)}>


                            <div className="d-flex flex-column col-12 col-md-11 mx-4 mb-5 mt-md-3 gap-2">

                                {/* Input fields */}

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">الخدمة</span>
                                    <input
                                        className={`form-control ${errors.nameAr && "border border-danger"}`}
                                        type="text"
                                        placeholder="اسم الخدمة"
                                        // onChange={(e) => { setValue("nameAr", e.target.value) }}
                                        required
                                        {...register("nameAr", { required: true, minLength: 10 })}
                                    />
                                    {errors.nameAr && <p className='errors-msg'>الاسم مطلوب أكبر من ١٠ أحرف</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">Service</span>
                                    <input
                                        className={`form-control ${errors.name && "border border-danger"}`}
                                        type="text"
                                        placeholder="Service Name"
                                        // onChange={(e) => { setValue("name", e.target.value) }}
                                        required
                                        {...register("name", { required: true, minLength: 10 })}
                                    />
                                    {errors.name && <p className='errors-msg'>الاسم مطلوب أكبر من ١٠ أحرف</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >مزود الخدمة
                                    </span>
                                    <input
                                        className='form-control'
                                        type="text"
                                        name='supplierName'
                                        required
                                        placeholder="مزود الخدمة"
                                        {...register("supplier.name", { required: true })}
                                    // onChange={(e) => { setValue("supplier.name", e.target.value) }}
                                    />
                                    {errors.supplierName && <p className='errors-msg'>أدخل اسم مزود الخدمة</p>}
                                </div>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >بريد مزود الخدمة</span>
                                    <input className='form-control text-start'
                                        type="email"
                                        placeholder="abc@mail.com"
                                        name='supplierEmail'
                                        required
                                        {...register("supplier.email", { required: true, pattern: emailValidation })}
                                    // onChange={(e) => { setValue("supplier.email", e.target.value) }}

                                    />
                                    {errors.supplierEmail && <p className='errors-msg'>أدخل البريدالالكتروني</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >جوال مزود الخدمة</span>
                                    <input className='form-control text-start'
                                        type="tel" placeholder="05xxxxxxxx"
                                        name='supplierPhone'
                                        required
                                        {...register("supplier.phone", { required: true, pattern: mobileValidation })}
                                    // onChange={(e) => { setValue("supplier.phone", e.target.value) }}

                                    />
                                    {errors.supplierPhone && <p className='errors-msg'>أدخل رقم الجوال الصحيح</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >متوفر</span>
                                    <select className='form-select text-start'
                                        {...register("enabled")}
                                    >
                                        <option value={true}>متوفر</option>
                                        <option value={false}>غير متوفر</option>
                                    </select>
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">تفاصيل</span>
                                    <textarea
                                        className={`form-control ${errors.descriptionAr && "border border-danger"}`}
                                        type="textArea"
                                        rows="5"
                                        // onChange={(e) => { setValue("descriptionAr", e.target.value) }}
                                        placeholder="تفاصيل الخدمة بالعربي"
                                        // required
                                        {...register("descriptionAr", { minLength: 10 })} />
                                    {errors.descriptionAr && <p className='errors-msg'> مطلوب أكبر من ١٠ أحرف</p>}
                                </div>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">Detials</span>
                                    <textarea
                                        className={`form-control ${errors.description && "border border-danger"}`}
                                        type="textArea"
                                        rows="5"
                                        // onChange={(e) => { setValue("description", e.target.value) }}
                                        placeholder="Detials in English"
                                        // required
                                        {...register("description", { minLength: 10 })} />
                                    {errors.description && <p className='errors-msg'> مطلوب أكبر من ١٠ أحرف</p>}
                                </div>



                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >صورة</span>
                                    <input className='form-control'
                                        type="file"
                                        accept="image/JPG"
                                        onChange={e => setValue("image", e.target.files[0])}
                                    />
                                    {errors.image && <p className='errors-msg'>يجب أن يكون صورة</p>}
                                </div>
                                <button
                                    className='btn btn-dark-orange text-white col-2 me-3 mb-3 position-absolute bottom-0 end-0'
                                    type="submit">
                                    {loading &&
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"></span>
                                    }
                                    حفظ
                                </button>
                            </div>



                        </form>
                        <SuccessErrorMsg
                            ToastContainer={ToastContainer}
                        />
                    </div>
                </div>
            </div>
        </div>

    )
}